export default "__VITE_ASSET__DKPBz8____"